import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, TextField } from 'hhsoig-design-system-core'
import css from './SearchForm.module.css'

export class SearchForm extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    term: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired
  }

  render() {
    const { label, term } = this.props
    return (
      <div className="ds-l-form-row ds-u-align-items--end ds-u-margin-bottom--4">
        <div className="ds-l-col--5">
          <TextField
            fieldRef={input => (this.searchQuery = input)}
            label={label}
            labelClassName="ds-u-margin-top--0"
            name="search-field"
            defaultValue={term}
          />
        </div>
        <div className="ds-l-col--auto">
          <div
            className={`ds-l-form-row ds-u-align-items--center ${
              css.buttonMargin
            }`}
          >
            <div className="ds-l-col--auto">
              <Button
                type="submit"
                variation="primary"
                onClick={this._onSubmit}
              >
                Search
              </Button>
            </div>
            <div className={`ds-l-col--auto ${css.clearLink}`}>
              <a onClick={this._clearFieldValue} href="javascript:void(0)">
                Clear search field
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onSubmit = e => {
    e.preventDefault()
    this.props.onSubmit(this.searchQuery.value)
  }

  _clearFieldValue = () => {
    this.searchQuery.value = ''
    this.setState({ term: '' })
    this.props.onSubmit('')
  }
}
